module.exports = __webpack_public_path__ + "static/media/Navisworks Manage.112894df.png";